import { Box, Button, Card, Slider, styled, Typography, IconButton } from "@mui/material"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState } from "react";


const StyledCard = styled(Card)(() => ({
    borderRadius: '20px',
    background: '#FFFFFF',
    border: '1px solid var(--Light-Gray)',
    padding: '32px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    '&:hover': {
      boxShadow: '0px 1px 2px 0px #0205111A',
    },
  }));

const StyledButton = styled(Button)(() => ({
    padding: '6px 14px',
    borderRadius: '8px',
    background: 'var(--Light-Gray)',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'var(--Interviewer-Green)',
}))

const RainbowSlider = styled(Slider)({
    height: '8px',
  
    '& .MuiSlider-rail': {
      height:'8px',
      backgroundColor: '#F0F1F3',
    },
  
    '& .MuiSlider-track': {
      height:'8px',
      border: 'none',
      background: 'linear-gradient(to right, #31C07D, #47C5FB, #9747FF, #EB4335)',
    },
  
    '& .MuiSlider-thumb': {
        height: '24px',
        width: '24px',
        backgroundColor: '#f44336',
        boxShadow: '0px 0px 6px rgba(0,0,0,0.3)',
        border: 'none',
        position: 'relative',

        '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: '#fff',
        },

        '&:hover': {
            boxShadow: '0px 0px 0px 4px rgba(244,67,54,0.16)',
        },
        
    },

    // '& .MuiSlider-markLabel': {
    //   whiteSpace: 'normal', // allows wrapping
    //   position: 'absolute', // removes absolute positioning
    //   transform: 'none',
    //   fontSize: '14px',
    //   color: '#999',
    //   marginTop: '8px',
    //   textAlign: 'center',
    // },

  });

interface CategoryCardProps {
  id: string;
  title: string;
  description: string;
  recommendedQuestions: number;
  onRemove: () => void;
  onQuestionsChange: (id: string, questions: number) => void;
}

const CategoryCard = ({ id, title, description, recommendedQuestions, onRemove, onQuestionsChange }: CategoryCardProps) => {
    const [value, setValue] = useState(recommendedQuestions);

    const handleChange = (_event: Event, newValue: number | number[]) => {
        const numericValue = newValue as number;
        setValue(numericValue);
        onQuestionsChange(id, numericValue);
    };

    return (
        <StyledCard>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: '16px'}}>
                    <Typography variant="h2">{title}</Typography>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '14px'}}>
                        <StyledButton>{value} Questions</StyledButton>
                        <IconButton 
                            onClick={onRemove}
                            sx={{ border: '1px solid var(--Light-Gray)', borderRadius: '8px', padding: '6px' }}
                        >
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Box>
                </Box>
                <Typography sx={{pb: '28px'}}>{description}</Typography>
                <Box sx={{ px: 2 }}>
                    <RainbowSlider
                        value={value}
                        onChange={handleChange}
                        max={99}
                        marks={[
                            { 
                                value: 0,
                                label: '0'
                            },
                            { value: 25, label: '25' },
                            { value: 50, label: '50' },
                            { value: 75, label: '75' },
                            { 
                                value: 99,
                                label: '99'
                            },
                        ]}
                        valueLabelDisplay="auto"
                    />
                </Box>
        </StyledCard>
    )
}
export default CategoryCard;